import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Frown } from "lucide-react";

export default function NotFound() {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 to-cyan-500 text-white min-h-[80vh] flex flex-col items-center justify-center overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="text-center px-6"
      >
        <motion.h1
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, duration: 0.4 }}
          className="text-8xl sm:text-9xl font-extrabold mb-2 drop-shadow-lg"
        >
          404
        </motion.h1>

        <div className="flex justify-center mb-4">
          <Frown size={50} className="text-cyan-200" />
        </div>

        <h2 className="text-2xl sm:text-3xl font-semibold mb-3">
          Oops! This page went on vacation 🌴
        </h2>

        <p className="text-blue-100 max-w-lg mx-auto mb-8">
          Looks like the page you’re looking for doesn’t exist or has been moved.  
          Don’t worry — our servers are still running at lightning speed ⚡
        </p>

        <Link
          to="/"
          className="inline-block bg-white text-blue-600 font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-transform duration-300"
        >
          ⬅️ Back to Home
        </Link>
      </motion.div>

      {/* Decorative floating elements */}
      <motion.div
        className="absolute top-10 left-10 w-24 h-24 bg-white/10 rounded-full blur-3xl"
        animate={{ y: [0, 20, 0] }}
        transition={{ duration: 6, repeat: Infinity }}
      />
      <motion.div
        className="absolute bottom-10 right-10 w-32 h-32 bg-white/10 rounded-full blur-2xl"
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 8, repeat: Infinity }}
      />
    </section>
  );
}
